import { z } from 'zod';
import { IdempotencyKeySchema } from './common.js';

export const PurchaseKindSchema = z.enum(['item', 'block', 'garden']);

export const PurchaseRequestSchema = z.object({
  kind: PurchaseKindSchema,
  id: z.string().optional(),
  qty: z.number().int().positive().optional(),
  idempotencyKey: IdempotencyKeySchema,
});
export type PurchaseRequest = z.infer<typeof PurchaseRequestSchema>;

export const PurchaseResponseSchema = z.object({
  balance: z.number().int().nonnegative(),
  ownedItems: z.array(z.string()).optional(),
  ownedBlocks: z.array(z.string()).optional(),
  gardenUnlocked: z.boolean().optional(),
});
export type PurchaseResponse = z.infer<typeof PurchaseResponseSchema>;

export const PetTargetTypeSchema = z.enum(['npc', 'companion', 'own']);

export const PetRequestSchema = z.object({
  targetType: PetTargetTypeSchema,
  targetId: z.string().min(1),
  idempotencyKey: IdempotencyKeySchema,
});
export type PetRequest = z.infer<typeof PetRequestSchema>;

export const PetResponseSchema = z.object({
  smiled: z.boolean(),
  rewardZl: z.number().int().nonnegative(),
  balance: z.number().int().nonnegative(),
});
export type PetResponse = z.infer<typeof PetResponseSchema>;

export const VisitsRequestSchema = z.object({
  placeId: z.string().min(1),
});
export type VisitsRequest = z.infer<typeof VisitsRequestSchema>;

export const VisitsResponseSchema = z.object({
  visited: z.array(z.string()),
  explorerBonus: z
    .object({
      rewardZl: z.number().int().positive(),
      balance: z.number().int().nonnegative(),
    })
    .optional(),
});
export type VisitsResponse = z.infer<typeof VisitsResponseSchema>;

export const SpinRequestSchema = z.object({
  idempotencyKey: IdempotencyKeySchema,
});
export type SpinRequest = z.infer<typeof SpinRequestSchema>;

export const SpinResponseSchema = z.object({
  tier: z.enum(['bogaty', 'normalny', 'biedny']),
  grantZl: z.number().int().nonnegative(),
  balance: z.number().int().nonnegative(),
});
export type SpinResponse = z.infer<typeof SpinResponseSchema>;
